import { Link } from "react-router-dom";
import { ReactNode } from "react";

export interface FAQItem {
  question: string;
  answer: ReactNode;
}

export interface FAQCategory {
  title: string;
  items: FAQItem[];
}

export const faqData: FAQCategory[] = [
  {
    title: "REGISTRACE",
    items: [
      {
        question: "Jak se registrovat?",
        answer: (
          <>
            <p><strong>Facebook nebo Google</strong></p>
            <p>Chceš se zaregistrovat raz dva? Udělej to přes Facebook nebo Google a máš hotovo. Nic víc už nemusíš.</p>
            <p><strong>Email</strong></p>
            <p>Pokud si zvolíš registraci přes email, čeká tě pár kroků.</p>
            <ol>
              <li>Zadej svůj email</li>
              <li>Zvol si heslo</li>
              <li>Potvrď verifikační email</li>
            </ol>
          </>
        ),
      },
      {
        question: "Registruji se podruhé a nejde mi dokončit registraci. Jak mám postupovat?",
        answer: (
          <p>
            Je možné, že v předchozí registraci byly uvedeny stejné údaje, které jsou jedinečné.
            Kontaktuj naši zákaznickou <Link to="/kontakt">podporu</Link>, která ti pomůže s novou registrací.
          </p>
        ),
      },
      {
        question: "Koukám do schránky a ověřovací email nikde.",
        answer: (
          <p>
            Zkontroluj spam, příchozí i nevyžádané emaily. Ověřovací email se tam nenachází?
            Podívej se do svého účtu, jestli je tvůj email zadán správně.
            Pokud ano, tak se obrať na naši <Link to="/kontakt">podporu</Link>. Společně to vyřešíme.
          </p>
        ),
      },
      {
        question: "Proč chcete mé osobní údaje?",
        answer: (
          <p>
            Je to především z důvodu, abychom věděli, komu poté výhru poslat a jak s tebou komunikovat.
            Nemusíš mít ale žádné obavy. Tvoje osobní údaje jsou u nás v naprostém bezpečí.
          </p>
        ),
      },
      {
        question: "Může se registrovat i cizinec?",
        answer: (
          <p>Ano, stačí zadat platný email a telefon a vyplnit řádně registrační formulář.</p>
        ),
      },
      {
        question: "Jak postupovat, když zapomenu heslo nebo email?",
        answer: (
          <p>
            V případě zapomenutého hesla stačí kliknout na Zapomenuté heslo v okně pro přihlášení.
            Pokud potřebuješ poradit, naše <Link to="/kontakt">podpora</Link> je tu pro tebe.
          </p>
        ),
      },
    ],
  },
  {
    title: "AUKCE",
    items: [
      {
        question: "O jaký typ aukce se jedná?",
        answer: (
          <p>
            Holandská aukce je typ aukce, při níž se cena prodávaného předmětu postupně snižuje,
            dokud se nenajde výherce. Začíná se na běžné tržní ceně předmětu a končí se až ve chvíli,
            kdy někdo projeví zájem a potvrdí nákup.
          </p>
        ),
      },
      {
        question: "Jaké jsou výhody holandské aukce?",
        answer: (
          <p>
            <strong>Spravedlnost.</strong> Holandské aukce jsou považovány za spravedlivé,
            protože všichni zájemci mají stejnou možnost snižovat cenu na draženém předmětu.
            Postupné snižování ceny zajišťuje, že o ceně položky nerozhoduje pouze jeden zájemce s nejvyšší nabídkou.
          </p>
        ),
      },
      {
        question: "Kdy se dozvím o začátku aukce?",
        answer: (
          <p>
            Aukce probíhají každý den. Někdy i vícekrát denně. Začátek aukce je plánován vždy v různou denní dobu,
            určenou dle tématu předmětu nebo služby v aukci. Na některé aukce ti, pokud to máš nastaveno,
            pošleme pozvánku předem emailem. Můžeš tak přijít včas a mít větší šanci na výhru.
          </p>
        ),
      },
      {
        question: "Kde lze sledovat rozpisy dalších chystaných aukcí?",
        answer: (
          <p>
            Nastav si pravidelný odběr našeho newsletteru, ve kterém tě budeme včas informovat o dalších aukcích.
          </p>
        ),
      },
      {
        question: "Jaká je nejlepší strategie pro holandskou aukci?",
        answer: (
          <>
            <ol>
              <li>
                <strong>Důkladný výzkum:</strong> Před účastí na aukci si důkladně prostuduj všechny informace
                o nabízeném zboží, jako jsou specifikace, tržní hodnota, dostupnost atd.
                To ti pomůže určit maximální cenu, kterou chceš zaplatit.
              </li>
              <li>
                <strong>Stanovení limitu:</strong> Urči si předem maximální cenu, kterou chceš za zboží zaplatit.
                Drž se tohoto limitu během aukce a vyhneš se přeplácení.
              </li>
              <li>
                <strong>Rychlé rozhodování:</strong> Holandská aukce vyžaduje rychlé rozhodování,
                protože cena klesá až do okamžiku, kdy někdo přijme aktuální nabídku.
                Když cena dosáhne tvé maximální představy, na nic nečekej a rychle reaguj.
              </li>
              <li>
                <strong>Sledování cen:</strong> Sleduj průběh aukce a ceny podobného zboží,
                které bylo v minulosti prodáno. To ti může pomoci lépe odhadnout vhodný okamžik pro přijetí nabídky.
              </li>
              <li>
                <strong>Trpělivost:</strong> Trpělivost vysněné věci přináší. Nech aukci probíhat,
                dokud cena nespadne na úroveň, která je pro tebe přijatelná.
                Nech se vést svým limitem a neuspěchej přijmout nabídku dříve.
              </li>
            </ol>
          </>
        ),
      },
      {
        question: "Co se stane, když opustím aukci v jejím průběhu?",
        answer: (
          <p>
            Nic se nestane. Z aukce můžeš kdykoliv odejít a zase přijít zpět,
            zkontrolovat její aktuální průběh nebo jak to dopadlo.
          </p>
        ),
      },
      {
        question: "Jak probíhá samotná aukce?",
        answer: (
          <>
            <p>Do aukce je nutné se přihlásit, tj. projít krok za krokem:</p>
            <ol>
              <li>Zaregistruj se na <strong>trefim.to</strong></li>
              <li>Počkej na zahájení aukce</li>
              <li>Klikni na "Snížit cenu". Tím snížíš cenu a posdílíš to také na Facebook. Více přátel v aukci = nižší cena pro všechny!</li>
              <li>Klikni na "Koupit hned", pokud jsi s nabízenou cenou spokojen!</li>
              <li>Těš se na další aukce</li>
            </ol>
          </>
        ),
      },
    ],
  },
  {
    title: "NÁKUP",
    items: [
      {
        question: "Mohu si předem nastavit cenu, za jakou chci aukci vyhrát?",
        answer: (
          <p>
            Ano. Cenu za jakou máš zájem dražený předmět koupit si můžeš nastavit.
            Jakmile nabídka klesne na tvoji hranici, pokračuješ do košíku, kde vyplníš údaje a dokončíš objednávku.
          </p>
        ),
      },
      {
        question: "Jak lze uhradit za vyhranou aukci?",
        answer: (
          <p>V aktuálním košíku online platební kartou.</p>
        ),
      },
      {
        question: "Co když nestihnu nákup potvrdit?",
        answer: (
          <p>
            Objednávku je potřeba dokončit bez zbytečného odkladu. Košík drží rezervaci jen omezenou dobu,
            takže pokud platbu nestihneš, je potřeba projít nákup znovu podle aktuálního stavu aukce.
          </p>
        ),
      },
      {
        question: "Je možné vrátit nebo vyměnit zboží zakoupené v aukci?",
        answer: (
          <p>
            Podmínky aukce a nabízeného předmětu si vždy stanovuje prodávající,
            tedy aktuální obchodní partner, který nabízí daný předmět nebo službu.
            Obecně lze říci, že jde o nákup plnohodnotného, nového předmětu nebo služby
            a s tím tedy spojené veškeré zákaznické výhody.
          </p>
        ),
      },
    ],
  },
  {
    title: "VÝHERCI",
    items: [
      {
        question: "Najdu někde přehled výherců proběhlých aukcí?",
        answer: (
          <p>
            Zobrazujeme jen vydražené výhry bez osobních údajů výherců.
            Pokud výherci budou chtít, mohou se pochlubit výhrou na našem Facebooku nebo Instagramu.
          </p>
        ),
      },
    ],
  },
  {
    title: "ÚČET",
    items: [
      {
        question: "Kde si mohu změnit své osobní údaje?",
        answer: (
          <p>
            Po registraci a přihlášení si můžeš měnit osobní údaje.
            Čím více si vyplníš předem v klidu, tím lépe se ti pak bude dražit,
            až tě zaujme nabídka aukce a hlavně výhodná cena!
          </p>
        ),
      },
      {
        question: "Co mám dělat, když zapomenu uživatelské heslo?",
        answer: (
          <p>
            Pod přihlašovacím polem se nachází tlačítko Zapomenuté heslo.
            Klikni na něj, vyplň svůj email a zvol Zaslat email.
            Za chvilku ti přijde email s možností nastavit nové heslo.
          </p>
        ),
      },
      {
        question: "Co mám dělat, když zapomenu přihlašovací jméno?",
        answer: (
          <p>
            Napiš email na ahoj@trefim.to. Naše <Link to="/kontakt">podpora</Link> ti ochotně pomůže.
          </p>
        ),
      },
      {
        question: "Nemohu se přihlásit ke svému účtu. Pomoc!",
        answer: (
          <p>
            Zůstaň v klidu, naše <Link to="/kontakt">podpora</Link> je tu pro tebe. Napiš email na ahoj@trefim.to.
          </p>
        ),
      },
      {
        question: "Jak zruším svůj účet?",
        answer: (
          <p>
            V tomto případě kontaktuj naši <Link to="/kontakt">podporu</Link>. Napiš email na ahoj@trefim.to.
          </p>
        ),
      },
    ],
  },
  {
    title: "NEWSLETTER",
    items: [
      {
        question: "Jak si nastavit newsletter?",
        answer: (
          <p>
            Můžeš si dát jen odběr newsletter v zápatí našeho webu nebo - doporučujeme -
            se rovnou registrovat, tím si také aktivuješ odběr newsletter a neuteče žádná zajímavá nabídka.
            Zrušit odběr můžeš kdykoliv po přihlášení.
          </p>
        ),
      },
    ],
  },
  {
    title: "DALŠÍ TÉMATA",
    items: [
      {
        question: "Mohu si aukci vyzkoušet zdarma?",
        answer: (
          <p>
            Jasně že jo! Všechny naše aukce si můžeš zkusit sledovat živě bez registrace a zcela zdarma.
            Pokud se budeš chtít zapojit, stačí se jen zaregistrovat a hurá na to!
          </p>
        ),
      },
      {
        question: "Kde najdu cookies nastavení?",
        answer: (
          <p>Všechno si v klidu můžeš kdykoliv nastavit zde.</p>
        ),
      },
      {
        question: "Za-za-za-sekla se mi aukce.",
        answer: (
          <p>
            Jsi v plném soustředění a aukce se najednou zasekne? Nic se neděje.
            Obnov webovou stránku a aukce se ti znovu načte.
          </p>
        ),
      },
    ],
  },
];
